export default __webpack_public_path__ + "static/media/logo-monochrome.e3a40801.svg";